/* ============================================================================
   DigX Slide Cart  (Wave 4 — qikify Slide Cart replacement, ТЗ §2.7)
   Vanilla JS over the Shopify Ajax Cart API. Drives the drawer DOM rendered by
   sections/digx-cart-drawer.liquid. Reuses the existing Nova Poshta picker
   (assets/nova-poshta.js → NovaPoshtaMain) 1-в-1 (see A0-FINDINGS.md).

   Public API: window.DigxCart.{open, close, toggle, refresh, addItem,
   changeQty, removeItem, getCart}
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-digx-cart]');
  if (!root) return;

  var cfgEl = document.querySelector('[data-digx-cart-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { CFG = {}; }

  // ---- DOM refs --------------------------------------------------------------
  var els = {
    drawer: root.querySelector('[data-digx-cart-drawer]'),
    scroll: root.querySelector('[data-digx-cart-scroll]'),
    items: root.querySelector('[data-digx-cart-items]'),
    empty: root.querySelector('[data-digx-cart-empty]'),
    count: root.querySelector('[data-digx-cart-count]'),
    foot: root.querySelector('[data-digx-cart-foot]'),
    subtotal: root.querySelector('[data-digx-subtotal]'),
    shipbar: root.querySelector('[data-digx-ship-bar]'),
    shipText: root.querySelector('[data-digx-ship-text]'),
    shipFill: root.querySelector('[data-digx-ship-fill]'),
    shipTruck: root.querySelector('[data-digx-ship-bar] .digx-cart__shipbar-truck'),
    dock: root.querySelector('[data-digx-cart-dock]'),
    tabs: root.querySelector('[data-digx-cart-tabs]'),
    np: root.querySelector('[data-digx-cart-np]'),
    note: root.querySelector('[data-digx-note]'),
    giftSection: root.querySelector('[data-digx-gift-section]'),
    giftItems: root.querySelector('[data-digx-gift-items]'),
    deliveryTab: root.querySelector('[data-digx-tab="delivery"]'),
    noteTab: root.querySelector('[data-digx-tab="note"]'),
    checkout: root.querySelector('[data-digx-checkout]')
  };

  var state = { cart: null, busy: false, npInited: false, opened: false, giftBusy: false, shipping: null };

  // ---- money -----------------------------------------------------------------
  function money(cents) {
    cents = cents || 0;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, CFG.moneyFormat || (window.theme && theme.money_format) || '{{amount}}');
    }
    return (cents / 100).toFixed(2);
  }

  function t(key, fallback) {
    return (CFG.strings && CFG.strings[key]) || fallback || '';
  }

  // ---- fetch helpers ---------------------------------------------------------
  function getJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); });
  }
  // Robust /cart.js read. The storefront cart endpoints occasionally return an HTML
  // challenge / rate-limit page instead of JSON on rapid bursts (Cloudflare/Shopify);
  // a naive .json() then throws. Retry a few times so a transient blip never reads as a
  // failure. Resolves to the cart object, or null if every attempt came back non-JSON.
  function getCartJSONRetry(tries) {
    tries = tries || 3;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        var ct = r.headers.get('content-type') || '';
        if (r.ok && (ct.indexOf('json') !== -1 || ct.indexOf('javascript') !== -1)) return r.json();
        throw new Error('cart-nonjson');
      })
      .catch(function () {
        if (tries > 1) return new Promise(function (res) { setTimeout(res, 350); }).then(function () { return getCartJSONRetry(tries - 1); });
        return null;
      });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ---- render ----------------------------------------------------------------
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // The gift switch must gate RECOGNITION, not just the auto-add. With the promo off
  // (Sasha 2026-07-28: «прибрати акцію з кошика») the gift block is not rendered at all,
  // so a line still sitting in someone's cart from before the switch would be filtered out
  // of the regular list and land in a block that does not exist: invisible in the drawer,
  // still in the cart, still charged at checkout. Promo off => it is an ordinary line.
  function isGift(item) {
    return CFG.giftEnable && CFG.giftVariantId && String(item.variant_id) === String(CFG.giftVariantId);
  }

  function itemHTML(item) {
    var img = item.image ? item.image.replace(/(\.[^.\/]*)(\?.*)?$/, '_120x120_crop_center$1') : (CFG.placeholder || '');
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? item.variant_title : '';
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (k.charAt(0) === '_' || item.properties[k] == null || item.properties[k] === '') return;
        props += '<p class="digx-cart__item-prop">' + escapeHtml(k) + ': ' + escapeHtml(item.properties[k]) + '</p>';
      });
    }
    var gift = isGift(item);
    var priceHtml;
    if (gift) {
      priceHtml = '<span class="digx-cart__item-price digx-cart__item-price--free">' + escapeHtml(t('giftFreeLabel', 'Безкоштовно')) + '</span>';
    } else if (item.original_line_price !== item.final_line_price) {
      priceHtml = '<span class="digx-cart__item-price"><s>' + money(item.original_line_price) + '</s>' + money(item.final_line_price) + '</span>';
    } else {
      priceHtml = '<span class="digx-cart__item-price">' + money(item.final_line_price) + '</span>';
    }

    var qtyControl = gift
      ? ''
      : '<div class="digx-cart__qty">' +
          '<button type="button" class="digx-cart__qty-btn" data-digx-qty-dec aria-label="' + escapeHtml(t('decrease', 'Менше')) + '">&minus;</button>' +
          '<input type="text" class="digx-cart__qty-num" value="' + item.quantity + '" inputmode="numeric" pattern="[0-9]*" data-digx-qty-input aria-label="' + escapeHtml(t('quantity', 'Кількість')) + '">' +
          '<button type="button" class="digx-cart__qty-btn" data-digx-qty-inc aria-label="' + escapeHtml(t('increase', 'Більше')) + '">+</button>' +
        '</div>';
    var trashSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M5 7h14M10 7V5h4v2M6 7l1 13h10l1-13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var removeControl = gift ? '' : '<button type="button" class="digx-cart__remove" data-digx-remove aria-label="' + escapeHtml(t('remove', 'Видалити')) + '">' + trashSvg + '</button>';

    // gift is NOT clickable (you can't accidentally navigate to / buy the gift)
    var name = escapeHtml(item.product_title || item.title);
    var imgInner = img ? '<img class="digx-cart__item-img" src="' + escapeHtml(img) + '" alt="' + name + '" loading="lazy">' : '<span class="digx-cart__item-img"></span>';
    var imgEl = gift
      ? '<span class="digx-cart__item-imglink" aria-hidden="true">' + imgInner + '</span>'
      : '<a href="' + escapeHtml(item.url) + '" class="digx-cart__item-imglink">' + imgInner + '</a>';
    var titleEl = gift
      ? '<span class="digx-cart__item-title">' + name + '</span>'
      : '<a href="' + escapeHtml(item.url) + '" class="digx-cart__item-title">' + name + '</a>';

    return '' +
      '<div class="digx-cart__item' + (gift ? ' digx-cart__item--gift' : '') + '" data-digx-line-key="' + escapeHtml(item.key) + '">' +
        imgEl +
        '<div class="digx-cart__item-main">' +
          titleEl +
          (variant ? '<p class="digx-cart__item-variant">' + escapeHtml(variant) + '</p>' : '') +
          props +
          qtyControl +
        '</div>' +
        '<div class="digx-cart__item-side">' +
          removeControl +
          priceHtml +
        '</div>' +
      '</div>';
  }

  function renderShipBar(cart) {
    if (!els.shipbar) return;
    var threshold = (CFG.freeShipThreshold || 0) * 100; // грн → cents
    if (!CFG.freeShipEnable || threshold <= 0) { els.shipbar.hidden = true; return; }
    els.shipbar.hidden = false;
    var total = giftAdjustedTotal(cart);
    var left = Math.max(0, threshold - total);
    var pct = Math.min(100, threshold ? (total / threshold) * 100 : 0);
    els.shipFill.style.width = pct + '%';
    if (els.shipTruck) els.shipTruck.style.left = pct + '%';
    if (left <= 0) {
      els.shipbar.classList.add('is-reached');
      els.shipText.innerHTML = escapeHtml(t('freeShipReached', 'Ви отримали безкоштовну доставку!'));
    } else {
      els.shipbar.classList.remove('is-reached');
      els.shipText.innerHTML = t('freeShipProgress', 'Додайте ще {amount} до безкоштовної доставки')
        .replace('{amount}', '<b>' + money(left) + '</b>');
    }
  }

  // subtotal excluding the gift line (so the ₴1 gift can't game the thresholds)
  function giftAdjustedTotal(cart) {
    var total = cart.total_price;
    (cart.items || []).forEach(function (it) { if (isGift(it)) total -= it.final_line_price; });
    return total;
  }

  // ---- free gift at threshold (A3: Dr Free Gift replacement, ТЗ §2.10) -------
  function giftEnabled() { return CFG.giftEnable && CFG.giftVariantId && (CFG.giftThreshold || 0) > 0; }
  function giftPresentItem(cart) {
    var m = (cart.items || []).filter(isGift);
    return m.length ? m[0] : null;
  }

  function renderGiftBar(cart) {
    var bars = document.querySelectorAll('[data-digx-gift-bar]');
    if (!bars.length) return;
    if (!giftEnabled()) { Array.prototype.forEach.call(bars, function (b) { b.hidden = true; }); return; }
    var threshold = (CFG.giftThreshold || 0) * 100;
    var left = threshold - giftAdjustedTotal(cart);
    Array.prototype.forEach.call(bars, function (b) {
      if (left > 0) {
        // below threshold → show the progress nudge
        b.hidden = false;
        b.classList.remove('is-added');
        b.innerHTML = String((CFG.strings && CFG.strings.giftProgress) || 'До безкоштовного подарунка лишилось {amount}').replace('{amount}', '<b>' + money(left) + '</b>');
      } else {
        // gift already in the cart → hide this bar (the gift block at the bottom shows it; no double label)
        b.hidden = true;
      }
    });
  }

  // auto add/remove the gift; reentrancy-guarded so the add/remove → render → reconcile
  // chain cannot loop, and the ₴1 gift is excluded from its own threshold (giftAdjustedTotal)
  function reconcileGift(cart) {
    if (!giftEnabled() || state.giftBusy) return;
    var threshold = (CFG.giftThreshold || 0) * 100;
    var sub = giftAdjustedTotal(cart);
    var present = giftPresentItem(cart);
    if (sub >= threshold && !present) {
      state.giftBusy = true;
      addItem(CFG.giftVariantId, 1).then(function () { state.giftBusy = false; }, function () { state.giftBusy = false; });
    } else if (sub < threshold && present) {
      state.giftBusy = true;
      changeQty(present.key, 0).then(function () { state.giftBusy = false; }, function () { state.giftBusy = false; });
    }
  }

  function render(cart) {
    state.cart = cart;
    var count = cart.item_count;
    if (els.count) els.count.textContent = count > 0 ? String(count) : '';
    // keep the native header count + cart-icon "full" state in sync
    Array.prototype.forEach.call(document.querySelectorAll('#CartCount'), function (el) { el.textContent = count; });
    Array.prototype.forEach.call(document.querySelectorAll('.js-cart-icon'), function (el) { el.classList.toggle('js-cart-full', count > 0); });

    var empty = count === 0;
    if (els.empty) els.empty.hidden = !empty;
    if (els.items) els.items.hidden = empty;
    if (els.foot) els.foot.hidden = empty;
    if (els.dock) els.dock.hidden = empty;          // fixed Доставка/коментар dock (not scrollable)
    if (empty) closeSheets();
    if (els.note && cart.note != null && cart.note !== 'null' && document.activeElement !== els.note) els.note.value = cart.note;

    // HARD GATE: block checkout until Nova Poshta delivery is chosen (real source of truth = cart attrs)
    var needsDelivery = !!els.np;                   // delivery sheet present (off the /cart page)
    root.classList.toggle('digx-cart--no-delivery', needsDelivery && !empty && !deliverySelected(cart));
    updateDeliveryTab(cart);                         // CART-2: reflect the chosen delivery on the collapsed Доставка tab
    updateNoteTab(cart);                             // reflect an entered comment on the collapsed note tab

    // paid items in the scroll list; gift(s) in a separate block at the bottom
    var regular = (cart.items || []).filter(function (it) { return !isGift(it); });
    var gifts = (cart.items || []).filter(isGift);
    if (els.items) els.items.innerHTML = empty ? '' : regular.map(itemHTML).join('');
    if (els.giftSection) {
      var showGift = !empty && gifts.length > 0;
      els.giftSection.hidden = !showGift;
      if (els.giftItems) els.giftItems.innerHTML = showGift ? gifts.map(itemHTML).join('') : '';
    }
    renderSummary(cart);
    renderShipBar(cart);
    renderGiftBar(cart);
    updateShipping(cart);

    // notify other modules that the cart re-rendered
    document.dispatchEvent(new CustomEvent('digx:cart:rendered', { detail: { cart: cart } }));

    // fades need the settled layout to know if the list overflows
    if (els.scroll) requestAnimationFrame(updateScrollFades);

    // auto add/remove the free gift last (async, reentrancy-guarded)
    reconcileGift(cart);
  }

  // scroll-affordance fades (Nikita 2026-07-18): a veil at the scroller's top/
  // bottom hints the list continues in that direction; each side dies at its end.
  function updateScrollFades() {
    var el = els.scroll;
    if (!el) return;
    balanceScrollPad(el);
    var max = el.scrollHeight - el.clientHeight;
    el.classList.toggle('can-scroll-up', el.scrollTop > 2);
    el.classList.toggle('can-scroll-down', max - el.scrollTop > 2);
  }
  if (els.scroll) els.scroll.addEventListener('scroll', updateScrollFades, { passive: true });

  // Scroller content must sit on the shared 16px column no matter what the
  // engine does with the custom scrollbar (classic 6px on desktop, overlay 0
  // on iOS/headless, 15px UA-default elsewhere): measure the real layout
  // width and pad the difference (Nikita 2026-07-18, red-lines flag).
  function balanceScrollPad(el) {
    if (!el || el.offsetWidth === 0) return;
    var want = Math.max(0, 16 - (el.offsetWidth - el.clientWidth)) + 'px';
    if (el.style.paddingRight !== want) el.style.paddingRight = want;
  }

  // ---- summary + promo (A2: Dr Stacked Discounts replacement, ТЗ §2.6) -------
  function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  // paints Вартість товарів / Знижка / Доставка / Всього (ТЗ §2.6.2); Всього = goods + shipping (Control)
  function paintTotals(cart) {
    var subtotal = (cart.original_total_price != null) ? cart.original_total_price : cart.items_subtotal_price;
    if (subtotal == null) subtotal = cart.total_price + (cart.total_discount || 0);
    var discount = cart.total_discount || 0;
    var ship = (typeof state.shipping === 'number') ? state.shipping : null; // cents, null = unknown
    all('[data-digx-sum-subtotal]').forEach(function (el) { el.innerHTML = money(subtotal); });
    all('[data-digx-sum-discount]').forEach(function (el) { el.innerHTML = '−' + money(discount); });
    all('[data-digx-sum-discount-row]').forEach(function (el) { el.hidden = !(discount > 0); });
    all('[data-digx-sum-shipping]').forEach(function (el) {
      if (ship == null) { el.classList.add('digx-cart__line-note'); el.textContent = (CFG.strings && CFG.strings.shippingNote) || 'Розраховується при оформленні'; }
      else { el.classList.remove('digx-cart__line-note'); el.textContent = ship === 0 ? ((CFG.strings && CFG.strings.giftFreeLabel) || 'Безкоштовно') : money(ship); }
    });
    var total = cart.total_price + (ship || 0);
    all('[data-digx-sum-total]').forEach(function (el) { el.innerHTML = money(total); });
    all('[data-digx-subtotal]').forEach(function (el) { el.innerHTML = money(total); }); // back-compat node
  }

  function renderSummary(cart) { paintTotals(cart); syncChip(cart); }

  // real shipping estimate (ТЗ §2.6.4 — Shopify Shipping Rates, Zone Україна). Free above the
  // free-ship threshold; else the cheapest UA rate. CF may block the call → falls back to a note.
  function updateShipping(cart) {
    if (CFG.shippingEnable === false) { state.shipping = null; return; }
    var threshold = (CFG.freeShipThreshold || 0) * 100;
    if (threshold > 0 && giftAdjustedTotal(cart) >= threshold) { state.shipping = 0; paintTotals(cart); return; }
    getJSON('/cart/shipping_rates.json?shipping_address%5Bcountry%5D=Ukraine&shipping_address%5Bcity%5D=%D0%9A%D0%B8%D1%97%D0%B2&shipping_address%5Bzip%5D=01001')
      .then(function (r) {
        var rates = (r && r.shipping_rates) || [];
        if (rates.length) {
          var cents = rates.map(function (x) { return Math.round(parseFloat(x.price) * 100); }).filter(function (n) { return !isNaN(n); });
          state.shipping = cents.length ? Math.min.apply(null, cents) : null;
        } else { state.shipping = null; }
        paintTotals(cart);
      })
      .catch(function () { state.shipping = null; paintTotals(cart); });
  }

  function codeApplications(cart) {
    var a = (cart.discount_applications || []).concat(cart.cart_level_discount_applications || []);
    return a.filter(function (x) { return x.type === 'discount_code'; });
  }
  function hasAutomatic(cart) {
    return (cart.discount_applications || []).some(function (a) { return a.type === 'automatic' || a.type === 'script'; });
  }
  function fmtMsg(tpl, code, amount) {
    return String(tpl || '').replace(/\{\{\s*code\s*\}\}/g, code || '').replace(/\{\{\s*amount\s*\}\}/g, amount || '');
  }
  function promoStr(k) { return (CFG.promo && CFG.promo[k]) || ''; }

  // Shopify reprices the cart AFTER the /discount/ hop asynchronously (measured 300-1000ms
  // on this store). A single immediate re-read loses that race and mislabels valid codes as
  // failed — the "works occasionally / differs per device" bug (root-caused 2026-07-19).
  // Poll with backoff until the discount materializes; only after the full window is it a miss.
  // Detection stays ROBUST: a discount_code application OR a total drop — never a
  // title==code match (application.title can be the discount's internal name).
  // Primary application path: the Ajax Cart API applies a code SYNCHRONOUSLY when the
  // platform accepts it — the response carries the repriced cart, no cookie race at all
  // (measured 2026-07-19: Firefox 200+td in ~1s; WebKit transient 409 → retry or fall back).
  function applyViaUpdate(code, attempt) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) {
      if (r.status === 409 && !attempt) {
        return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return applyViaUpdate(code, 1); });
      }
      if (!r.ok) return null;
      return r.json().catch(function () { return null; });
    }).catch(function () { return null; });
  }

  function waitForPromo(prevDiscount) {
    // Fallback verify for the /discount cookie hop. Measured lag spectrum: WebKit ~700ms,
    // Firefox up to ~8s+ (2026-07-19 probes). The window must cover the tail — a valid code
    // resolving late is worse than a slow "invalid" verdict. Resolves on the FIRST hit.
    var delays = [250, 450, 700, 1100, 1600, 2300, 3700]; // ~10.1s worst case
    var last = null;
    function attempt(i) {
      return getCartJSONRetry(2).then(function (c) {
        if (c) {
          last = c;
          var applied = codeApplications(c).length > 0 || (c.total_discount || 0) > prevDiscount;
          if (applied) return { cart: c, applied: true };
        }
        if (i >= delays.length) return { cart: last, applied: false };
        return new Promise(function (res) { setTimeout(res, delays[i]); }).then(function () { return attempt(i + 1); });
      });
    }
    return attempt(0);
  }

  function showPromoMsg(text, kind) {
    all('[data-digx-promo-msg]').forEach(function (el) {
      el.textContent = text || '';
      el.hidden = !text;
      el.className = 'digx-promo__msg' + (kind ? ' is-' + kind : '');
    });
  }
  function hidePromoMsg() { all('[data-digx-promo-msg]').forEach(function (el) { el.hidden = true; el.textContent = ''; }); }
  // state swap is CSS-driven: toggle .is-couponed on the slot (form + ticket cross-fade/morph);
  // no `hidden` toggling anymore (display:none is not transitionable = the old snap).
  function showChip(code, saved) {
    all('[data-digx-promo-code]').forEach(function (el) { el.textContent = code; });
    all('[data-digx-promo-saved]').forEach(function (el) { el.textContent = saved || ''; });
    all('[data-digx-promo-slot]').forEach(function (el) { el.classList.add('is-couponed'); });
  }
  function hideChip() {
    all('[data-digx-promo-slot]').forEach(function (el) { el.classList.remove('is-couponed'); });
    all('[data-digx-promo-chip]').forEach(function (el) { el.classList.remove('is-removing'); });
    all('[data-digx-promo-input]').forEach(function (el) { el.value = ''; });
    all('[data-digx-promo-saved]').forEach(function (el) { el.textContent = ''; });
  }
  function syncChip(cart) {
    var apps = codeApplications(cart);
    if (apps.length) {
      var saved = (cart && cart.total_discount > 0) ? '-' + money(cart.total_discount) : '';
      showChip(apps[0].title, saved);
    } else {
      all('[data-digx-promo-slot]').forEach(function (el) { el.classList.remove('is-couponed'); });
      all('[data-digx-promo-saved]').forEach(function (el) { el.textContent = ''; });
    }
  }
  function setPromoLoading(b) { all('[data-digx-promo-apply]').forEach(function (el) { el.classList.toggle('is-loading', b); el.disabled = b; }); }
  // delete feedback lives ON the ticket — the apply-button spinner is parked/hidden while couponed
  function setCouponRemoving(b) {
    all('[data-digx-promo-chip]').forEach(function (el) { el.classList.toggle('is-removing', b); });
    all('[data-digx-promo-remove]').forEach(function (el) { el.disabled = b; });
  }

  function applyPromo(code) {
    code = (code || '').trim();
    if (!code) return Promise.resolve();
    var cart = state.cart;
    if (!cart || cart.item_count === 0) { showPromoMsg(promoStr('empty'), 'error'); return Promise.resolve(); }
    // /discount/ on *.myshopify.com 301s cross-origin to fizi.ua, so the discount session
    // can never land there (admin-preview sessions). Say so instead of a false "Йой".
    if (/\.myshopify\.com$/.test(location.hostname)) {
      showPromoMsg('Промокоди працюють лише на fizi.ua. Відкрийте сайт на fizi.ua і спробуйте ще раз.', 'error');
      return Promise.resolve();
    }
    // if a code is already applied, clear it first so a swap is clean and the re-read is accurate
    // (codes don't combine — Shopify replaces the old one; clearing avoids a stale transitional read)
    var existing = codeApplications(cart).length > 0;
    var prevDiscount = existing ? 0 : (cart.total_discount || 0);
    var hadAuto = hasAutomatic(cart);
    setPromoLoading(true);
    var pre = existing ? postJSON('/cart/update.js', { discount: '' }) : Promise.resolve();
    // Try the synchronous Cart API first; only fall back to the /discount cookie hop
    // (native discount session, carries to checkout) when the platform refuses.
    return pre
      .then(function () { return applyViaUpdate(code); })
      .then(function (direct) {
        if (direct && (direct.total_discount || 0) > prevDiscount) {
          // applied synchronously — confirm with a canonical cart.js read for render()
          return getCartJSONRetry(2).then(function (c) { return { cart: c || direct, applied: true }; });
        }
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () { return waitForPromo(prevDiscount); });
      })
      .then(function (out) {
        var c = out && out.cart;
        // Couldn't read the cart at all (transient HTML/challenge) — do NOT blame the
        // code (it may be perfectly valid + already set for checkout). Ask to retry instead.
        if (!c) { showPromoMsg(promoStr('retry') || 'Не вдалося перевірити кошик 😕 Спробуйте ще раз.', 'error'); return; }
        render(c);
        var nowDiscount = c.total_discount || 0;
        var applied = out.applied;
        if (applied) {
          var amt = nowDiscount > 0 ? money(nowDiscount) : '';
          showPromoMsg(fmtMsg(promoStr('success'), code, amt), 'success');
          showChip(code, amt ? '-' + amt : '');
        } else if (hadAuto) {
          // an automatic discount is active and the typed code didn't take → conflict
          showPromoMsg(fmtMsg(promoStr('conflict'), code), 'error');
        } else {
          // genuinely did not apply (invalid / conditions not met). NOTE: on the *.myshopify.com
          // preview /discount/ redirects to fizi.ua (separate cart) so codes can't apply there —
          // they work on the primary fizi.ua domain.
          showPromoMsg(fmtMsg(promoStr('error'), code), 'error');
        }
      })
      .catch(function () { showPromoMsg(fmtMsg(promoStr('error'), code), 'error'); })
      .then(function () { setPromoLoading(false); });
  }

  function removePromo() {
    setCouponRemoving(true);
    // POST /cart/update.js with an empty discount is the ONLY storefront call that actually
    // clears an applied code (verified live: total_discount 12000 -> 0). The old /discount/
    // overwrite hack left the code applied — the FIZI-Spain "can't remove the code" bug.
    return postJSON('/cart/update.js', { discount: '' })
      .then(function () { return refresh(); })
      .then(function () { hideChip(); hidePromoMsg(); setCouponRemoving(false); })
      .catch(function () { setCouponRemoving(false); });
  }

  // ---- Доставка / Твій коментар sheet OVERLAYS (open on top of the drawer, like Control) ----
  function deliverySelected(cart) {
    var a = (cart && cart.attributes) || {};
    return !!(a._delivery_warehouse_Number || a._delivery_warehouse || a._delivery_courier_address || a._delivery_street);
  }
  // CART-2: short human label of the chosen delivery, built from the cart attrs NovaPoshtaMain wrote
  function deliverySummary(cart) {
    var a = (cart && cart.attributes) || {};
    var city = (a._delivery_city || '').split(',')[0].trim();
    var place = a._delivery_warehouse_name || a._delivery_warehouse || a._delivery_courier_address || a._delivery_street || '';
    if (place) place = String(place).replace(/\s*:\s*/, ' №');   // "Відділення:5" → "Відділення №5"
    return [city, place].filter(Boolean).join(' · ');
  }
  function updateDeliveryTab(cart) {
    var sel = deliverySelected(cart);
    var sumEl = root.querySelector('[data-digx-delivery-summary]');
    if (sumEl) {
      var txt = sel ? deliverySummary(cart) : '';
      sumEl.textContent = txt;
      sumEl.hidden = !txt;
    }
    if (els.deliveryTab) els.deliveryTab.classList.toggle('digx-cart__tab--filled', sel);
  }
  // reflect an entered comment on the collapsed "Твій коментар" tab (violet filled state + check)
  function updateNoteTab(cart) {
    var v = (cart && cart.note != null && cart.note !== 'null') ? String(cart.note) : '';
    if (!v && els.note) v = els.note.value || '';
    if (els.noteTab) els.noteTab.classList.toggle('digx-cart__tab--filled', !!v.trim());
  }
  function closeSheets() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-digx-tab]'), function (t) { t.setAttribute('aria-expanded', 'false'); t.classList.remove('is-active'); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-digx-sheet]'), function (s) { s.hidden = true; });
    root.classList.remove('digx-cart--sheet-open');
  }
  function openSheet(name) {
    var sheet = root.querySelector('[data-digx-sheet="' + name + '"]');
    if (!sheet) return;
    closeSheets();
    sheet.hidden = false;
    root.classList.add('digx-cart--sheet-open');
    balanceScrollPad(sheet.querySelector('.digx-cart__sheet-body'));
    var tab = root.querySelector('[data-digx-tab="' + name + '"]');
    if (tab) { tab.setAttribute('aria-expanded', 'true'); tab.classList.add('is-active'); }
    if (name === 'delivery') initNovaPoshta();
  }
  function closeSheet() { closeSheets(); refresh(); }  // re-read cart → re-evaluate the delivery gate
  // back-compat alias (older callers) — render() calls closeTabs() on empty
  function closeTabs() { closeSheets(); }
  function setTab(name) { openSheet(name); }

  // ---- cart ops --------------------------------------------------------------
  function refresh() {
    return getJSON('/cart.js').then(function (cart) { render(cart); return cart; });
  }

  function setBusy(b) { state.busy = b; root.classList.toggle('is-loading', b); }
  // same restore trap as the checkout latch (Nikita 2026-07-28): a cart write that was in
  // flight when the shopper left leaves `is-loading` on, and a page that comes BACK
  // restored would show a permanently dimmed drawer. Coming back always means not busy.
  window.addEventListener('pageshow', function () { setBusy(false); });

  function changeQty(key, qty) {
    setBusy(true);
    return postJSON('/cart/change.js', { id: key, quantity: qty })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () { return refresh(); })
      .then(function (cart) { setBusy(false); return cart; });
  }

  function removeItem(key) { return changeQty(key, 0); }

  function addItem(id, qty, props) {
    var body = { id: id, quantity: qty || 1 };
    if (props) body.properties = props;
    return postJSON('/cart/add.js', body).then(function () { return refresh(); });
  }

  // optimistic qty handling
  function optimisticQty(itemEl, key, nextQty) {
    if (nextQty < 0) return;
    itemEl.classList.add('is-pending');
    var input = itemEl.querySelector('[data-digx-qty-input]');
    if (input) input.value = nextQty;
    if (nextQty === 0) { removeItem(key); return; }
    changeQty(key, nextQty);
  }

  // ---- open / close ----------------------------------------------------------
  function open() {
    if (state.opened) return;
    state.opened = true;
    // Scroll-lock rev 2 (Nikita 2026-07-18): leave the page layout COMPLETELY
    // untouched (the earlier overflow-hidden + gutter/padding compensation each
    // shifted something). The page scrollbar stays rendered; scrolling outside
    // the drawer is blocked at the event level instead.
    root.classList.add('is-open');
    document.body.classList.add('digx-cart-open');
    root.setAttribute('aria-hidden', 'false');
    refresh().then(initNovaPoshta);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('wheel', onScrollBlock, { passive: false });
    document.addEventListener('touchmove', onScrollBlock, { passive: false });
  }
  function close() {
    state.opened = false;
    root.classList.remove('is-open');
    document.body.classList.remove('digx-cart-open');
    root.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);
    document.removeEventListener('wheel', onScrollBlock, { passive: false });
    document.removeEventListener('touchmove', onScrollBlock, { passive: false });
  }
  function toggle() { state.opened ? close() : open(); }
  var SCROLL_KEYS = [' ', 'PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', 'Home', 'End'];
  function onKeydown(e) {
    if (e.key === 'Escape') { close(); return; }
    // keyboard page-scroll with focus outside the drawer would move the page behind the lock
    if (SCROLL_KEYS.indexOf(e.key) > -1 && !e.target.closest('.digx-cart__drawer')) e.preventDefault();
  }
  function onScrollBlock(e) {
    if (!e.target.closest || !e.target.closest('.digx-cart__drawer')) e.preventDefault();
  }

  // ---- Nova Poshta (reuse NovaPoshtaMain 1-в-1) ------------------------------
  function initNovaPoshta() {
    // panel is collapsed behind the "Доставка" tab by default — the #nova-poshta element is
    // still in the DOM, so wire NovaPoshtaMain on open regardless of panel visibility.
    if (state.npInited) return;
    if (!document.getElementById('nova-poshta') || typeof window.NovaPoshtaMain !== 'function') return;
    state.npInited = true;
    var tr = CFG.np || {};
    window.NP_API_KEY = window.NP_API_KEY || tr.apiKey;
    window.quickCityIndices = tr.quickCityIndex || window.quickCityIndices || '';
    window.methodBranch = tr.methodBranch; window.methodCourier = tr.methodCourier;
    window.titleDelivery = tr.titleDelivery; window.alertKeyboard = tr.alertKeyboard;
    window.alertCity = tr.alertCity; window.alertWarehouse = tr.alertWarehouse;
    window.alertStreet = tr.alertStreet;
    window.checkoutButton = els.checkout;
    window.checkoutButtonWrapper = root.querySelector('.checkout-button-wrap');
    window.pageType = 'cart';
    try { window.NovaPoshtaMain(); } catch (e) { /* degrade gracefully */ state.npInited = false; }
  }

  // ---- event wiring ----------------------------------------------------------
  // close (overlay / X / grip) + sheet back/Готово + Доставка/коментар tab → open sheet
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-digx-cart-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-digx-sheet-close]')) {
      e.preventDefault();
      // Готово in the DELIVERY sheet with a picked point = the shopper's explicit
      // confirmation → continue straight to checkout (Nikita 2026-07-18: a confirm
      // step, not an auto-jump on pick). Back-arrow/X and Готово without a picked
      // point keep just closing the sheet.
      var confirmBtn = e.target.closest('.digx-cart__sheet-confirm');
      var fromDelivery = confirmBtn && confirmBtn.closest('[data-digx-sheet="delivery"]');
      closeSheet();
      if (fromDelivery) {
        refresh().then(function () {
          if (deliverySelected(state.cart) && els.checkout) els.checkout.click();
        });
      }
      return;
    }
    var tab = e.target.closest('[data-digx-tab]');
    if (tab) { e.preventDefault(); openSheet(tab.getAttribute('data-digx-tab')); }
  });

  // cart note (Твій коментар) → /cart/update.js
  if (els.note) {
    els.note.addEventListener('change', function () {
      postJSON('/cart/update.js', { note: els.note.value }).catch(function () {});
      if (els.noteTab) els.noteTab.classList.toggle('digx-cart__tab--filled', !!els.note.value.trim());
    });
  }

  // HARD delivery gate (independent of NovaPoshtaMain, which un-gates itself on NP API error):
  // while no delivery is chosen, the checkout is blocked; hovering highlights "Доставка" and
  // clicking opens the delivery sheet. Capture-phase + stopImmediatePropagation prevents the
  // NovaPoshtaMain checkout handler from firing when gated. When ungated, it proceeds normally.
  if (els.checkout && els.deliveryTab) {
    var coWrap = root.querySelector('.checkout-button-wrap') || els.checkout;
    var gated = function () { return root.classList.contains('digx-cart--no-delivery'); };
    var pulse = function (on) { els.deliveryTab.classList.toggle('digx-cart__tab--pulse', !!on && gated()); };
    coWrap.addEventListener('mouseenter', function () { pulse(true); });
    coWrap.addEventListener('mouseleave', function () { pulse(false); });
    coWrap.addEventListener('click', function (e) {
      if (gated()) { e.preventDefault(); e.stopImmediatePropagation(); pulse(false); openSheet('delivery'); }
    }, true);
  }

  // qty + remove (delegated)
  if (els.items) {
    els.items.addEventListener('click', function (e) {
      var itemEl = e.target.closest('[data-digx-line-key]');
      if (!itemEl) return;
      var key = itemEl.getAttribute('data-digx-line-key');
      var input = itemEl.querySelector('[data-digx-qty-input]');
      var cur = input ? parseInt(input.value, 10) || 0 : 0;
      if (e.target.closest('[data-digx-qty-inc]')) { optimisticQty(itemEl, key, cur + 1); }
      else if (e.target.closest('[data-digx-qty-dec]')) { optimisticQty(itemEl, key, cur - 1); }
      else if (e.target.closest('[data-digx-remove]')) { e.preventDefault(); itemEl.classList.add('is-pending'); removeItem(key); }
    });
    els.items.addEventListener('change', function (e) {
      if (!e.target.matches('[data-digx-qty-input]')) return;
      var itemEl = e.target.closest('[data-digx-line-key]');
      var key = itemEl.getAttribute('data-digx-line-key');
      var n = parseInt(e.target.value, 10);
      if (isNaN(n) || n < 0) { refresh(); return; }
      itemEl.classList.add('is-pending');
      changeQty(key, n);
    });
  }

  // ANY cart link/icon opens our drawer — capture phase beats the <a href> + jQuery.
  // Catches .js-cart-icon (mobile), the desktop .secondary-nav__link "Кошик (N)", footer
  // links, etc. — anything whose href resolves to the cart route. (The /cart page itself
  // has no such link, so this never traps the page.)
  var CART_PATH = (window.theme && theme.routes && theme.routes.cartUrl) || '/cart';
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href], .js-cart-icon, .js-cart-draw-icon');
    if (!a) return;
    var isCart = a.classList.contains('js-cart-icon') || a.classList.contains('js-cart-draw-icon');
    if (!isCart && a.getAttribute && a.getAttribute('href')) {
      try { isCart = new URL(a.href, location.origin).pathname.replace(/\/$/, '') === CART_PATH.replace(/\/$/, ''); } catch (err) {}
    }
    if (isCart && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); e.stopPropagation(); open();
    }
  }, true);

  // ADD-TO-CART: DigxCart owns it (no reliance on the native ajaxCart / qsc2 event).
  // Capture-phase + stopImmediatePropagation prevents the native jQuery submit handler
  // from also adding (no double-add). Falls back to a normal submit only on hard error.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('.js-product-form, form[action^="/cart/add"], form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"], .js-product-add');
    if (btn) btn.classList.add('is-adding');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { if (btn) btn.classList.remove('is-adding'); if (CFG.openOnAdd) open(); else initNovaPoshta(); })
      .catch(function (err) {
        if (btn) btn.classList.remove('is-adding');
        if (err && err.status === 422) { /* sold out / invalid — leave page as-is */ refresh(); }
        else { form.submit(); } // network failure → let the browser do a normal add
      });
  }, true);

  // Belt-and-braces: if anything else still dispatches the legacy qsc2 add event, honour it.
  document.addEventListener('qsc2-event-drawer-open', function () {
    refresh().then(function () { if (CFG.openOnAdd) open(); else initNovaPoshta(); });
  });

  // promo apply / remove (delegated — covers the drawer + the /cart instance)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-digx-promo-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[data-digx-promo-input]');
    applyPromo(input ? input.value : '');
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-digx-promo-remove]')) { e.preventDefault(); removePromo(); }
  });

  // NO swipe-down-to-close (removed 2026-07, Sasha: "свайп вниз закриває" — the gesture
  // fired on any 70px downward touch while the list was at scroll-top, i.e. constantly
  // while using the delivery sheet / promo / totals). Closing = overlay, grip, or X only.

  // ---- expose ----------------------------------------------------------------
  window.DigxCart = {
    open: open, close: close, toggle: toggle, refresh: refresh,
    addItem: addItem, changeQty: changeQty, removeItem: removeItem,
    applyPromo: applyPromo, removePromo: removePromo,
    getCart: function () { return state.cart; }
  };

  // prime count + summaries on load (drawer stays closed); also populates the /cart promo widget
  function prime() { getJSON('/cart.js').then(function (c) { render(c); }).catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prime);
  else prime();
})();
